// Sigorta kayıtlarının yapısı: Insurances/{id}
//   employeeId, employeeName, hasBES, cost (toplam),
//   accidentInsurance / complementaryHealth / malpractice: { startDate, endDate, cost }
// Tarihler 'YYYY-MM-DD' metni olarak saklanır.

export const INSURANCE_TYPES = ['accidentInsurance', 'complementaryHealth', 'malpractice'];

const DAY_MS = 24 * 60 * 60 * 1000;

const startOfToday = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
};

export const parseDate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

/** 'expired' | 'soon' (within a month) | 'ok' | 'none' for an end date. */
export const endState = (endDate) => {
  const end = parseDate(endDate);
  if (!end) return 'none';
  const today = startOfToday();
  const oneMonthFromNow = new Date();
  oneMonthFromNow.setMonth(oneMonthFromNow.getMonth() + 1);
  if (end < today) return 'expired';
  if (end <= oneMonthFromNow) return 'soon';
  return 'ok';
};

/** Days left until an end date (negative once passed), or null. */
export const daysLeft = (endDate) => {
  const end = parseDate(endDate);
  if (!end) return null;
  end.setHours(0, 0, 0, 0);
  return Math.round((end - startOfToday()) / DAY_MS);
};

// Bitiş tarihi bugün ile 1 ay sonrası arasında olan bir türü var mı (eski kural)
export const isExpiringSoon = (insurance) => {
  const today = new Date();
  const oneMonthFromNow = new Date();
  oneMonthFromNow.setMonth(oneMonthFromNow.getMonth() + 1);
  const checkDate = (date) => {
    if (!date) return false;
    const expiryDate = new Date(date);
    return !Number.isNaN(expiryDate.getTime()) && expiryDate <= oneMonthFromNow && expiryDate >= today;
  };
  return INSURANCE_TYPES.some((type) => checkDate(insurance[type]?.endDate));
};

export const isBlank = (value) => value === null || value === undefined || value === ''
  || (typeof value === 'number' && Number.isNaN(value))
  || (typeof value === 'string' && ['nan', 'nat', 'n/a', 'null', 'undefined'].includes(value.toLowerCase()));

export const initialsOf = (name) => {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  return (parts.length === 1 ? parts[0].slice(0, 2) : `${parts[0][0]}${parts[parts.length - 1][0]}`).toLocaleUpperCase('tr-TR');
};
